function normalizeIdentity(value) {
    if (value === null || value === undefined) return null;
    const normalized = String(value).trim();
    return normalized || null;
}

function buildIdentitySet(values) {
    const identities = new Set();

    values.forEach((value) => {
        const normalized = normalizeIdentity(value);
        if (normalized) identities.add(normalized);
    });

    return identities;
}

function getPlayerIdentities(player) {
    return buildIdentitySet([
        player?._id,
        player?.userId,
        player?.steamId,
        player?.steamId64,
        player?.steam64Id,
    ]);
}

function getFriendIdentities(friend) {
    const friendData = friend?.friendData;

    return buildIdentitySet([
        friend?.friendSteamId,
        friendData?._id,
        friendData?.userId,
        friendData?.steamId,
        friendData?.steamId64,
        friendData?.steam64Id,
    ]);
}

export function friendMatchesPlayer(friend, player) {
    if (!friend || !player) return false;

    const playerIdentities = getPlayerIdentities(player);
    if (playerIdentities.size === 0) return false;

    const friendIdentities = getFriendIdentities(friend);
    for (const identity of friendIdentities) {
        if (playerIdentities.has(identity)) return true;
    }

    return false;
}

export function findFriendRecordForPlayer(friends, player) {
    if (!Array.isArray(friends)) return undefined;
    return friends.find((friend) => friendMatchesPlayer(friend, player));
}
